import { render, staticRenderFns } from "./c-instructions-alert.vue?vue&type=template&id=e0d8d946&"
import script from "./c-instructions-alert.vue?vue&type=script&lang=js&"
export * from "./c-instructions-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports